import { motion } from "framer-motion";

const logoGroups = [
  {
    label: "Primary proof",
    brands: [
      { name: "POP UPI", color: "#A855F7" },
      { name: "ZET", color: "#22C55E" },
      { name: "Littlebox", color: "#F59E0B" },
    ],
  },
  {
    label: "Verified client work",
    brands: [
      { name: "Zivame", color: "#EC4899" },
      { name: "Clovia", color: "#FB7185" },
      { name: "PlusGold", color: "#FACC15" },
      { name: "Amul", color: "#60A5FA" },
    ],
  },
  {
    label: "App-growth focus",
    brands: [
      { name: "App Reputation", color: "#06B6D4" },
      { name: "ASO", color: "#A78BFA" },
      { name: "Review Intelligence", color: "#F59E0B" },
      { name: "Store Conversion", color: "#34D399" },
    ],
  },
];

function BrandChip({ brand }) {
  return (
    <div className="logo-wordmark-card group" data-testid={`trusted-brand-${brand.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
      <span
        className="font-display text-lg font-semibold tracking-[0.1em] text-white/[0.42] transition-all duration-300 group-hover:scale-105 group-hover:[color:var(--brand-color)]"
        style={{ "--brand-color": brand.color }}
      >
        {brand.name}
      </span>
    </div>
  );
}

function MarqueeRow({ group, secondary = false }) {
  const doubled = [...group.brands, ...group.brands];

  return (
    <div className="grid gap-3 lg:grid-cols-[140px_1fr] lg:items-center">
      <div className="text-xs uppercase tracking-[0.26em] text-white/[0.42]">{group.label}</div>
      <div
        className="trust-marquee marquee-mask relative"
        data-testid={secondary ? `trusted-marquee-row-${group.label.toLowerCase()}-secondary` : `trusted-marquee-row-${group.label.toLowerCase()}-primary`}
      >
        <div className="trust-edge-fade left" />
        <div className="trust-edge-fade right" />
        <div className={`trust-marquee-track ${secondary ? "secondary" : ""}`}>
          {doubled.map((brand, index) => (
            <BrandChip key={`${group.label}-${brand.name}-${index}`} brand={brand} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default function TrustedBySection() {
  return (
    <section className="relative overflow-hidden px-6 pb-12 pt-6 sm:px-8 lg:px-12 lg:pb-16 lg:pt-10" data-testid="trusted-by-section">
      <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-transparent via-violet-500/[0.03] to-transparent" />
      <div className="relative mx-auto max-w-7xl rounded-[2.75rem] border border-white/[0.06] bg-gradient-to-b from-[#0B0B15] via-[#090A13] to-[#07070D] px-5 py-10 sm:px-8 lg:px-10 lg:py-12">
        <motion.div
          initial={{ opacity: 0, y: 22 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="mx-auto max-w-4xl text-center"
        >
          <p className="section-kicker">Credibility</p>
          <h2 className="mx-auto mt-5 max-w-[13ch] font-display text-3xl font-semibold tracking-[-0.04em] text-white sm:text-4xl lg:text-5xl" data-testid="trusted-by-heading">
            Trusted for app growth, ASO, and reputation work
          </h2>
          <p className="mx-auto mt-5 max-w-3xl text-sm leading-8 text-white/[0.62]">
            Real client work across app reputation, ASO, review intelligence, store conversion, and organic app growth.
          </p>
        </motion.div>

        <div className="mt-10 space-y-4">
          {logoGroups.map((group, index) => (
            <MarqueeRow key={group.label} group={group} secondary={index % 2 === 1} />
          ))}
        </div>

        <p className="mt-10 text-center text-sm uppercase tracking-[0.24em] text-white/[0.5]" data-testid="trusted-by-subline">
          Real apps • real growth • measurable results
        </p>
      </div>
    </section>
  );
}